/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiASkip2ForwardIcon16Light } from './MediaUiASkip2ForwardIcon16Light';
import { MediaUiASkip2ForwardIcon16Regular } from './MediaUiASkip2ForwardIcon16Regular';
import { MediaUiASkip2ForwardIcon16Solid } from './MediaUiASkip2ForwardIcon16Solid';
import { MediaUiASkip2ForwardIcon20Light } from './MediaUiASkip2ForwardIcon20Light';
import { MediaUiASkip2ForwardIcon20Regular } from './MediaUiASkip2ForwardIcon20Regular';
import { MediaUiASkip2ForwardIcon20Solid } from './MediaUiASkip2ForwardIcon20Solid';
import { MediaUiASkip2ForwardIcon24Regular } from './MediaUiASkip2ForwardIcon24Regular';
import { MediaUiASkip2ForwardIcon24Solid } from './MediaUiASkip2ForwardIcon24Solid';
import { MediaUiASkip2ForwardIcon32Regular } from './MediaUiASkip2ForwardIcon32Regular';
import { MediaUiASkip2ForwardIcon64Regular } from './MediaUiASkip2ForwardIcon64Regular';
var sizes = {
    16: {
        light: MediaUiASkip2ForwardIcon16Light,
        regular: MediaUiASkip2ForwardIcon16Regular,
        solid: MediaUiASkip2ForwardIcon16Solid,
    },
    20: {
        light: MediaUiASkip2ForwardIcon20Light,
        regular: MediaUiASkip2ForwardIcon20Regular,
        solid: MediaUiASkip2ForwardIcon20Solid,
    },
    24: {
        regular: MediaUiASkip2ForwardIcon24Regular,
        solid: MediaUiASkip2ForwardIcon24Solid,
    },
    32: {
        regular: MediaUiASkip2ForwardIcon32Regular,
    },
    64: {
        regular: MediaUiASkip2ForwardIcon64Regular,
    },
};
export var MediaUiASkip2ForwardIcon = forwardRef('MediaUiASkip2ForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
